import _ from 'lodash'
import { fetchResources } from '../../store/modules/resources/actions'
import { WithContentfulPage } from '../../components/WithContentfulPage'
import ResourceCategories from '../../containers/ResourceCategories'
const ResourceCategoriesPage = () => {
  return (
      <ResourceCategories />
  )
}

ResourceCategoriesPage.getInitialProps = async ({ store, pathname, query }) => {
    store.dispatch(
      fetchResources({
        resourceType: 'resourcesCategory',
        requestKey: 'resourcesCategory',
      })
    )
}


export default WithContentfulPage(ResourceCategoriesPage)
